(function () {
  function hasInventoryData(variant) {
    console.log(variant)
    return variant && variant.inventory_policy !== undefined && variant.inventory_quantity !== undefined;
  }

  function getJson(script) {
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function getSelectedOptions(variantSelects) {
    return Array.from(variantSelects.querySelectorAll('select, fieldset'))
      .map(function (optionGroup) {
        if (optionGroup.tagName === 'SELECT') {
          return optionGroup.selectedOptions[0]?.dataset.optionValue || optionGroup.value;
        }
        return optionGroup.querySelector('input:checked')?.dataset.optionValue;
      })
      .filter(Boolean);
  }

  function getSelectedVariant(variants, selectedOptions) {
    return variants.find(function (variant) {
      return (
        selectedOptions.length === variant.options.length &&
        variant.options.every(function (option, index) {
          return option === selectedOptions[index];
        })
      );
    });
  }

  function initDeliveryTime(container) {
    if (!container || container.dataset.deliveryTimeInit === 'true') return;

    var productInfo = container.closest('product-info');
    var preorderLine = container.querySelector('[data-delivery-preorder]');
    var instockLine = container.querySelector('[data-delivery-instock]');

    if (!productInfo || !preorderLine || !instockLine) return;

    var enablePreorder = container.dataset.enablePreorder === 'true';

    function getVariants() {
      var variantsScript = productInfo.querySelector('script[data-product-variants]');
      if (!variantsScript) return [];

      return getJson(variantsScript) || [];
    }

    function getInventoryMap() {
      var inventoryScript = productInfo.querySelector('script[data-delivery-variant-inventory]');
      return getJson(inventoryScript) || {};
    }

    function getSelectedVariantFromJson(variantSelects) {
      var selectedVariantScript = variantSelects?.querySelector('[data-selected-variant]');
      if (!selectedVariantScript?.textContent) return null;

      return getJson(selectedVariantScript);
    }

    function addInventoryData(variant, inventoryMap) {
      if (!variant) return null;

      var inventory = inventoryMap[String(variant.id)];
      if (!inventory) return variant;

      return Object.assign({}, variant, inventory);
    }

    function updateDeliveryTime() {
      var variants = getVariants();
      var inventoryMap = getInventoryMap();
      var variantSelects = productInfo.querySelector('variant-selects');
      var selectedOptions = variantSelects ? getSelectedOptions(variantSelects) : [];
      var currentVariantId = productInfo.querySelector('[data-atc-form] [name="id"]')?.value;
      var selectedVariant = getSelectedVariantFromJson(variantSelects);
      var variantById = variants.find(function (item) {
        return String(item.id) === String(currentVariantId);
      });
      var variantByOptions = getSelectedVariant(variants, selectedOptions);
      var variant = [variantById, variantByOptions, selectedVariant]
        .map(function (item) {
          return addInventoryData(item, inventoryMap);
        })
        .find(hasInventoryData);

      if (!variant) return;

      var isPreorder =
        enablePreorder &&
        variant.inventory_policy === 'continue';

      preorderLine.hidden = !isPreorder;
      instockLine.hidden = isPreorder;
    }

    updateDeliveryTime();
    container.dataset.deliveryTimeInit = 'true';
  }

  function initAllDeliveryTimes() {
    document.querySelectorAll('[data-delivery-time-message]').forEach(initDeliveryTime);
  }

  function initDeliveryTimesWithRetry() {
    initAllDeliveryTimes();
    if (document.querySelector('[data-delivery-time-message]:not([data-delivery-time-init="true"])')) {
      requestAnimationFrame(initAllDeliveryTimes);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeliveryTimesWithRetry, { once: true });
  } else {
    initDeliveryTimesWithRetry();
  }

  if (!window.deliveryTimelineChangeListener) {
    window.deliveryTimelineChangeListener = true;
    document.addEventListener('change', function (event) {
      var variantSelects = event.target.closest('variant-selects');
      var variantInput = event.target.matches('[data-atc-form] [name="id"]') ? event.target : null;
      var productInfo = variantSelects?.closest('product-info') || variantInput?.closest('product-info');
      var deliveryBlock = productInfo?.querySelector('[data-delivery-time-message]');

      if (!deliveryBlock) return;

      requestAnimationFrame(function () {
        delete deliveryBlock.dataset.deliveryTimeInit;
        initDeliveryTime(deliveryBlock);
      });
    });
  }
})();
